import { debounce } from "lodash";
import { useCallback, useState } from "react";
import { fetchDropDownData } from "../fetchDropDownData";

export const PurchaseOrderUtils = () => {
    const [supplierOptions, setSupplierOptions] = useState<any[]>([]);
    const [supplierParts, setSupplierParts] = useState<any[]>([]);
    const [partOptions,setPartOptions] = useState<any[]>([])

    const fetchSupplierOptions = useCallback(
        debounce((inputValue) => {
            fetchDropDownData({
                endpoint: "/contributors",
                searchKey: "code",
                searchTerm: inputValue,
                labelKey: "code",
                valueKey: "_id",
            }).then((data) => {
                const filteredSuppliers = data.filter(
                    (supplier: any) => supplier.type === "SUPPLIER" || supplier.type === "CUSTOMER&SUPPLIER"
                );

                const formattedSuppliers = filteredSuppliers.map((supplier: any) => ({
                    label: supplier.code, 
                    value: supplier._id, 
                }));


                setSupplierOptions(formattedSuppliers);
            });
        }, 500),
        []
    );

    const fetchSupplierParts = async (supplierId: string) => {
        try {
            const data : any = await fetchDropDownData({
                endpoint: "/supplierparts", 
                searchKey: "supplierId",    
                searchTerm: supplierId,
                labelKey: "supplierId",       
                valueKey: "_id",           
            });

            console.log("supplier parts response from grnutils",data);

            const formattedSuppliers = data.map((supplier: any) => ({
                label: supplier.partDetails.internalPartNo, 
                value: supplier._id, 
                partName: supplier.partDetails.partName,
                uom:supplier.uoms.name,
                unitPrice:supplier.unitPrice,
                gst:supplier.gst,
                igst:supplier.igst,
                sgst:supplier.sgst,
                cgst:supplier.cgst
            }));

            setPartOptions(formattedSuppliers)
            
            return formattedSuppliers;
        } catch (error) {
            console.error("Error fetching supplier parts:", error);
        }
    };  

    const fetchOnSearchPartDetails = async (inputvalue:string) => {
        try {
            const data : any = await fetchDropDownData({
                endpoint: "/supplierparts", 
                searchKey: "partDetails.internalPartNo",    
                searchTerm: inputvalue,
                labelKey: "partDetails.internalPartNo",       
                valueKey: "partDetails._id",           
            });

            // console.log("supplier parts response from grnutils",data);

            const formattedSuppliers = data.map((supplier: any) => ({
                label: supplier.partDetails.internalPartNo, 
                value: supplier._id, 
                partName: supplier.partDetails.partName,
                uom:supplier.uoms.name,
                unitPrice:supplier.unitPrice,
                gst:supplier.gst,
                igst:supplier.igst,
                sgst:supplier.sgst,
                cgst:supplier.cgst
            }));

            setPartOptions(formattedSuppliers)
            
            return formattedSuppliers;
        } catch (error) {
            console.error("Error fetching supplier parts:", error);
        }
    }


    return {
        supplierOptions,
        setSupplierOptions,
        fetchSupplierOptions,
        supplierParts,
        setSupplierParts,
        fetchSupplierParts,
        fetchOnSearchPartDetails,
        partOptions
    };
};
